import { BaseEntity } from './../../shared';

export class Item implements BaseEntity {
    constructor(
    	public id?: number, // Just to valid interface
        public productCode?: string,
        public invoiceName?: string,
        public preNumber?: string,
        public taxNumber?: string,
        public symbol?: string,
        public unit?: string,
        public unitId?: string,
        public unitName?: string,
        public number?: string,
        public buyerFullName?: string,
        public unitBuyerName?: string,
        public telNumber?: string,
        public paymentMethod?: string,
        public paymentStatus?: any,
        public items?: any,
        public checked?: boolean,
        public beRelease?: boolean,
        public beApprove?: boolean,
        public invoiceTemplateId?: number,
        public invoiceSymbolId?: string,
        public no?: any,
        public address?: string,
        public taxCode?: string,
        public companyName?: string,
        public total?: number,
        public taxCodeCurrentUser?: number,
        public taxTotal?: number,
        public taxId?: number,
        public sum?: number,
        public fax?: string,
        public personContact?: string,
        public delegate?: string,
        public bankAccount?: string,
        public accountHolder?: string,
        public bankName?: string,
        public description?: string,
        public account?: any,
        public customerAddress?: string,
        public mobile?: string,
        public customerCode?: string,
        public typePayment?: string,
        public amountInWords?: string,
        public code?: string,
        public note?: string,
        public customerName?: string,
        public companyAddress?: string,
        public companyNameCurrentUser?: string,
        public customerId?: number,
        public invoiceCode?: string,
        public released?: boolean,
        public invoiceDate?: string,
        public invoiceDateClient?: string,
        public dateRelease?:string,
        public email?: string,
        public data?: any,
        public status?: any,
        public paymented?: any,
        public noCalTotal?: boolean,
        public verificationTax?: any,
        public totalDiscount?: number,
        public totalDiscountTax?:number,
        public discountPercent?: number,
        public noCalTax?: boolean,
        public noCalDiscount?: boolean,
        public adjustmentType?: number,
        public invoiceSample? : number,
        public originNo?: string,
        public parentSymbol?: string,
        public parentCode? : string,
        public fileReceipt?: string | any,
        public fileReceiptTemp?: string | any,
    ) {
    }
}
